export default {
	loading: {
		position: 'fixed',
		top: '50%',
		left: '50%',
		zIndex: '10',
		transform: 'translate(-50%, -50%)',
	},
	cardHeader: {
		position: 'absolute',
	},
}
